/**
 * `/shop/<slug>/table/<eventId>` — the table this vendor is operating today, nested under the shop
 * that owns it (TRO-1187).
 *
 * The same screen as `/browse/<eventId>`, which table QR codes encode and which therefore keeps
 * rendering permanently. A customer who arrives there stays there: rewriting the URL onto this
 * path was tried during TRO-1187 and reverted, because `history.replaceState` left Back pointing
 * at the entry it had overwritten, so leaving the shop no longer returned to the table.
 *
 * The event id stays in the path because a vendor can operate two tables at once (ADR-0012), so
 * the slug alone cannot say which one a customer is standing at.
 */
export { default } from "../../../browse/[eventId]";
